import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { removeSuffix3d61x5lsuvuho as removeSuffix } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { Regexxgw0gjiagf4z as Regex } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/regex.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_camelRegex() {
  _init_properties_Page_kt__j5c6s1();
  return camelRegex;
}
var camelRegex;
var DirectClass;
function Direct() {
  if (DirectClass === VOID) {
    class $ {
      constructor(title, render) {
        title = title === VOID ? '' : title;
        this.sd6_1 = render;
        this.td6_1 = new (Constant())(_Constant___init__impl__v45mub(title));
      }
      ud6(_this__u8e3s4) {
        return this.sd6_1(_this__u8e3s4);
      }
      ucv() {
        return this.td6_1;
      }
    }
    initMetadataForClass($, 'Direct', VOID, VOID, [Page()]);
    DirectClass = $;
  }
  return DirectClass;
}
function get_title() {
  return new (Constant())(_Constant___init__impl__v45mub(removeSuffix(removeSuffix(camelToHuman(toString(getKClassFromExpression(this).ff())), ' Screen'), ' Page')));
}
var PageClass;
function Page() {
  if (PageClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Page');
    PageClass = $;
  }
  return PageClass;
}
function camelToHuman(_this__u8e3s4) {
  _init_properties_Page_kt__j5c6s1();
  var tmp2 = get_camelRegex();
  // Inline function 'kotlin.text.replace' call
  var transform = camelToHuman$lambda;
  return tmp2.xh(_this__u8e3s4, transform);
}
function camelToHuman$lambda(it) {
  _init_properties_Page_kt__j5c6s1();
  return it.ui().q1(1) + ' ' + it.ui().q1(2);
}
var properties_initialized_Page_kt_aanf75;
function _init_properties_Page_kt__j5c6s1() {
  if (!properties_initialized_Page_kt_aanf75) {
    properties_initialized_Page_kt_aanf75 = true;
    camelRegex = Regex().qh('([a-z])([A-Z]+)');
  }
}
//region block: exports
export {
  Direct as Direct1onk7bpgb7kpa,
  get_title as get_titlelss9nf4gv6ut,
  Page as Page1o437w9xuocrm,
};
//endregion

//# sourceMappingURL=Page.mjs.map
